import { Listing } from 'src/app/models/listing.model';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ListingService } from '@app/core/services/listing.service';

@Component({
  selector: 'app-my-listing',
  templateUrl: './my-listing.component.html',
  styleUrls: ['./my-listing.component.css'],
  providers: []
})
export class MyListingComponent implements OnInit {
  public list: any;
  get ifNotRoot(): boolean {
    return this.router.url.includes('/my-listing/');
  }

  constructor(
    private lisitngService: ListingService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    // const userID = JSON.parse(localStorage.getItem('user')).uid;
    // this.lisitngService.getUserList(userID).subscribe(list => {
    //   const listStorage = list.map(e => {
    //     return { id: e.payload.doc.id, ...(e.payload.doc.data() as object) } as Listing;
    //   });
    //   this.list = listStorage;
    // });
    this.route.data.subscribe(data => {
      const listings = data.listings;
      this.list = listings.map(e => {
        return { id: e.payload.doc.id, ...(e.payload.doc.data() as object) } as Listing;
      });
    });
  }

  goToDetails(listingID) {
    this.router.navigate(['profile/my-listing', listingID]);
  }
}
